import {
  FormArray,
  FormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-guide-one',
  templateUrl: './guide-one.component.html',
})
export class GuideOneComponent {
  brainstormForm = this.fb.group({
    inputs: this.fb.array([]),
    brainstorm: ['', Validators.required],
  });

  inspirationList = [
    {
      index: 1,
      value: 'Favorite childhood vacation',
      color: 'rgb(77, 101, 141)',
    },
    {
      index: 2,
      value: 'Winning a major competition',
      color: 'rgb(17, 102, 17)',
    },
    {
      index: 3,
      value: 'The worst storm I ever been in',
      color: 'rgb(148, 33, 146)',
    },
    {
      index: 4,
      value: 'My favorite job',
      color: 'rgb(46, 139, 87)',
    },
    {
      index: 5,
      value: 'My most memorable birthday',
      color: 'rgb(128, 29, 21)',
    },
    {
      index: 6,
      value: 'Growing up with my siblings',
      color: 'rgb(70, 130, 180)',
    },
  ];

  submit = false;

  constructor(private fb: FormBuilder, private router: Router) {}

  addInput() {
    (this.brainstormForm.controls.inputs as FormArray).push(
      this.fb.control('')
    );
  }
  ngClassValidate(group: UntypedFormGroup, name: string): string {
    if (!this.submit) return '';
    return group.controls[name].errors ? 'is-invalid' : 'is-valid';
  }

  onSubmit() {
    this.router.navigate(['../step-two']).then();
  }
}
